import { useState, useEffect } from 'react';
import { Router, Route, Link } from './index';
import Dashboard from '@components/Dashboard/Dashboard';
import Features from '@components/Widgets/Features';
import Templates from '@components/Templates/Templates';
import Settings from '@components/Settings/Settings';
import { routes } from 'admin/settings/routes';
import { Loader } from '@bsf/force-ui';
import Onboarding from '@components/Onboarding/Onboarding.jsx';


const CustomRouter = () => {
  const [loaded, setLoaded] = useState(false);
   const firstTimeUser = false

  useEffect(() => {
    setTimeout(() => {
      setLoaded(true);
    }, 1000); // Simulating a load delay of 1 second
  }, []);

  if (!loaded) {
    return (
      <div
        className="loading-spinner flex items-center justify-center h-screen"
        style={{ background: "#F9FAFB" }}
      >
        <Loader icon={null} size="lg" variant="primary" />
      </div>
    );
  }

  return (
    <Router routes={routes} defaultRoute={routes?.dashboard?.path}>
    <Route path={routes.dashboard.path}><Dashboard /></Route>
    <Route path={routes.onboarding.path}><Onboarding /></Route>
    <Route path={routes.widgets.path}><Features /></Route>
    <Route path={routes.templates.path}><Templates /></Route>
    <Route path={routes.settings.path}><Settings /></Route>
  </Router>
  );
};

export default CustomRouter;